import React from 'react';
import {formatDate, fromNow} from '../../utils';

const ParkingOpeningAlertBar = ({ openTime }) => {

  return (
    <div className="alert alert-info fade in">
      {`You can reserve spots on ${formatDate(openTime)} (${fromNow(openTime)})`}
    </div>
  );

};

export default ParkingOpeningAlertBar;



// WEBPACK FOOTER //
// ./src/containers/NavOptions/ParkingOpeningAlertBar.js